import { Deserializable } from "@app/interfaces/deserializable";
import { AgreementStatus } from "@app/enumerations/agreement-status";
import { Mxna } from '@app/models/mxna';
import { CustomerDocument } from '@app/models/customer-document';
import { BehaviorSubject, Observable } from 'rxjs';
import { Mxlocation } from './mxlocation';
import { Webauthentication } from './webauthentication';

/**
 * Usage: acceptedAgreement: AgreementStatus = AgreementStatus.NONE; 
 */

export class PersonPortalState implements Deserializable {   
    
    id: number;
    co: string;
    userName: string;
    micaAccountName: string;
    acctNum: string;    
    mxna: Mxna;
    loggedIn: boolean = false;
    //passwordExpirationTime: Date;
    acceptedAgreement: AgreementStatus = AgreementStatus.NONE;
    webauthenticationId: Webauthentication;    
    customerDocuments: CustomerDocument[];   
    token: string;

    deserialize(input: any) {
        Object.assign(this, input);
        return this;
    }
}
